export default "__VITE_ASSET__B_UaVDMB__"